import React, { Component } from 'react';
import { Modal } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import videoLogo from '../../assets/landingpage/videoLogo.png';
import css from './BAHBenifitsSection.css';

const ModalVideo = props => {
  return (
    <div className={css.videoContentWrapper}>
      <iframe
        id="videoIframe"
        className={css.iframeVideo}
        allowFullScreen={true}
        src="https://www.youtube.com/embed/OaOzjZiVaws">
      </iframe>
    </div>
  )
}

class BAHBenifitsSection extends Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false };
    this.handleOpen = this.handleOpen.bind(this);
  }

  handleOpen() {
    this.setState({ isOpen: true })
  }

  render() {
    const {
      onManageDisableScrolling
    } = this.props;

    return (
      <section className={css.benifitSection}>
        <div className={css.box1}>
          <div className={css.textBox1}>
            <h3 className={css.textBoxTitle1}>
              <FormattedMessage id="BecomeAHostPage.benifitTitle1" values={{ newline: (<br />) }} />
            </h3>
            <div className={css.textBoxDesc1}>
              <FormattedMessage id="BecomeAHostPage.benifitDesc1" values={{ newline: (<br />) }} />
            </div>
          </div>
          <div className={css.videoWrapper}>
            <div
              onClick={this.handleOpen}
              className={css.video}
            >
              <img className={css.videoLogo} src={videoLogo} alt="See how Long and short term car rental works | Drive lah" />
            </div>
          </div>
          <Modal
            id="videoLandingpage"
            {...this.props}
            containerClassName={css.modalContainer}
            closeButtonClassName={css.modalCloseButton}
            contentClassName={css.contentModal}
            isOpen={this.state.isOpen}
            onClose={() => {
              const videoIframe = document.querySelector("#videoIframe");
              if (videoIframe) {
                const iframeSrc = videoIframe.src;
                videoIframe.src = iframeSrc;
              }
              this.setState({ isOpen: false });
            }}
            onManageDisableScrolling={onManageDisableScrolling}
          >
            <ModalVideo />
          </Modal>
        </div>
        <div className={css.seperateLine}></div>
        <div className={css.box2}>
          <h4 className={css.textBoxTitle1}>
            <FormattedMessage id="BecomeAHostPage.benifitTitle2" values={{ newline: (<br />) }} />
          </h4>
          <div className={css.listTextBox}>
            <div className={css.subBox}>
              <div className={css.subBoxTitle}>
                <FormattedMessage id="BecomeAHostPage.subBoxTitle1" values={{ newline: (<br />) }} />
              </div>
              <div className={css.subBoxDesc}>
                <FormattedMessage id="BecomeAHostPage.subBoxDesc1" values={{ newline: (<br />) }} />
              </div>
            </div>
            <div className={css.subBox}>
              <div className={css.subBoxTitle}>
                <FormattedMessage id="BecomeAHostPage.subBoxTitle2" values={{ newline: (<br />) }} />
              </div>
              <div className={css.subBoxDesc}>
                <FormattedMessage id="BecomeAHostPage.subBoxDesc2" values={{ newline: (<br />) }} />
              </div>
            </div>
            <div className={css.subBox}>
              <div className={css.subBoxTitle}>
                <FormattedMessage id="BecomeAHostPage.subBoxTitle3" values={{ newline: (<br />) }} />
              </div>
              <div className={css.subBoxDesc}>
                <FormattedMessage id="BecomeAHostPage.subBoxDesc3" values={{ newline: (<br />) }} />
              </div>
            </div>
          </div>
        </div>
        {/* <div className={css.seperateLine}></div> */}
      </section>
    );
  }
}

export default BAHBenifitsSection;
